import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import BaseComponent from 'foundation/base-component';
import store from 'general/js/store';
import CustomEventLeaderboardLayout from './custom-event-leaderboard-layout';

class CustomEventLeaderboardComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        ReactDOM.render(
            <Provider store={store}>
                <CustomEventLeaderboardLayout options={this.options} />
            </Provider>,
            this.element
        );
    }
}

export default CustomEventLeaderboardComponent;
